import { Link } from "@tanstack/react-router";

export default function Author() {
  return (
    <section className="m-5 rounded-xl bg-sky-700 p-10 text-white">
      <div className="mb-5">
        <Link to="/about-roamdoc/frank-melo-md">
          <img
            src="/frank-melo-md.png"
            alt="Frank Melo, MD"
            className="mx-auto rounded-full"
            width={200}
            height={200}
          />
        </Link>
      </div>
      <div>
        <p>
          Hello! I'm Dr. Frank Melo, a dedicated Anesthesiologist with a diverse
          career spanning over 35 years. My journey in medicine has been marked
          by a commitment to providing top-notch anesthetic care in both small
          towns and rural areas, where I believe my expertise makes a
          significant difference.
        </p>

        <p>
          My medical journey began with a residency at New York Methodist
          Hospital, culminating in a specialized Cardiac Fellowship at New York
          Medical College.
        </p>
      </div>
    </section>
  );
}
